import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Flex } from '../Flex/index.js';

const InputElement = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    placement = 'left',
    disablePointerEvents = false,
    fontSize = 'fontSize20',
    size = 40,
    ...rest
  } = _ref;
  const placementProp = {
    [placement]: '0'
  };
  return /*#__PURE__*/React__default.createElement(Flex, _extends({
    ref: forwardedRef,
    alignItems: "center",
    fontSize: fontSize,
    justifyContent: "center",
    position: "absolute",
    size: size,
    top: "0"
  }, disablePointerEvents && {
    pointerEvents: 'none'
  }, placementProp, rest), children);
});
InputElement.displayName = 'InputElement';
/**
 * InputLeftElement is used to add an
 * icon to the left of the Input component.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/input/#input-w-icon)
 * <br />
 *
 */
const InputLeftElement = /*#__PURE__*/forwardRef((rest, forwardedRef) => /*#__PURE__*/React__default.createElement(InputElement, _extends({
  ref: forwardedRef,
  placement: "left"
}, rest)));
InputLeftElement.displayName = 'InputLeftElement';
/**
 * InputRightElement is used to add an
 * icon to the right of the Input component.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/input/#input-w-icon)
 * <br />
 *
 */
const InputRightElement = /*#__PURE__*/forwardRef((rest, forwardedRef) => /*#__PURE__*/React__default.createElement(InputElement, _extends({
  ref: forwardedRef,
  placement: "right"
}, rest)));
InputRightElement.displayName = 'InputRightElement';

export { InputElement, InputLeftElement, InputRightElement };
